import { render, staticRenderFns } from "./peopleJob-info.vue?vue&type=template&id=3e6d7eee&scoped=true&"
import script from "./peopleJob-info.vue?vue&type=script&lang=js&"
export * from "./peopleJob-info.vue?vue&type=script&lang=js&"
import style0 from "./peopleJob-info.vue?vue&type=style&index=0&lang=css&"
import style1 from "./peopleJob-info.vue?vue&type=style&index=1&id=3e6d7eee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d7eee",
  null
  
)

export default component.exports